module.exports = __webpack_public_path__ + "static/there-is-a-whole-world-out-there-ddd87f39d2b3a8565fa8b26c4576a147.jpg";